import { fromContentBuilderColor } from '@shared/utils/content-builder-color/content-builder-color';
import { IContentBuilderFieldColor } from '../models/content-builder-fields.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contentBuilderColor',
  standalone: true,
})
export class ContentBuilderColorPipe implements PipeTransform {
  transform(
    contentBuilderColor?: IContentBuilderFieldColor,
    defaultFallback?: string | IContentBuilderFieldColor,
  ): string {
    return fromContentBuilderColor(contentBuilderColor, defaultFallback);
  }
}
